import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true"

import "./HomePage.vue?vue&type=style&index=0&id=15589991&scoped=true&lang=css"
/* custom blocks */
import block0 from "./HomePage.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15589991"]])

export default __exports__